import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, WashDto, WashReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import WashInline from "./WashInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: WashDto | WashReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function WashLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.WashRead]}
      to={ROUTE_PATH.WASH_VIEW(entity?.id || entityId || "")}
      content={<WashInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
